document.addEventListener('DOMContentLoaded', () => {
    const body = document.body; // Body select kiya ek hi dafa

    // ==============================
    // ✅ Hamburger Menu Toggle
    // ==============================
    const menuToggle = document.getElementById("menuToggle"); // Hamburger button
    const closeMenu = document.getElementById("closeMenu"); // Close button
    const menuDrawer = document.getElementById("shopify-section-sections--24265687204166__header_navigation_compact_e7xjqN"); // Drawer

    function toggleMenu() {
        const isOpen = menuDrawer.classList.contains("open");
        if (isOpen) {
            menuDrawer.classList.remove("open");
            body.classList.remove("active");
        } else {
            menuDrawer.classList.add("open");
            body.classList.add("active");
        }
    }

    menuToggle.addEventListener("click", function (event) {
        event.stopPropagation();
        toggleMenu();
    });

    closeMenu.addEventListener("click", function (event) {
        event.stopPropagation();
        toggleMenu();
    });

    document.addEventListener("click", function (event) {
        if (!menuDrawer.contains(event.target) && !menuToggle.contains(event.target)) {
            menuDrawer.classList.remove("open");
            body.classList.remove("active");
        }
    });

    // ==============================
    // ✅ Search Bar Toggle
    // ==============================
    const searchIcon = document.querySelector(".search-icon-ps"); // Search button
    const closeSearch = document.querySelector(".search-close-icon"); // Close button
    const searchDrawer = document.querySelector(".custom-search-bar"); // Search drawer

    function toggleSearch() {
        const isOpen = searchDrawer.classList.contains("open");
        if (isOpen) {
            searchDrawer.classList.remove("open");
            body.classList.remove("search-active");
        } else {
            searchDrawer.classList.add("open");
            body.classList.add("search-active");
        }
    }

    searchIcon.addEventListener("click", function (event) {
        event.stopPropagation();
        toggleSearch();
    });

    closeSearch.addEventListener("click", function (event) {
        event.stopPropagation();
        toggleSearch();
    });

    document.addEventListener("click", function (event) {
        if (!searchDrawer.contains(event.target) && !searchIcon.contains(event.target)) {
            searchDrawer.classList.remove("open");
            body.classList.remove("search-active");
        }
    });
});
